import { QueryClient } from '@tanstack/react-query'
import { ApiError } from '../api/client'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (count, error) => {
        if (error instanceof ApiError && [400, 404].includes(error.status)) return false
        return count < 1
      },
      retryDelay: (attempt, error) => {
        if (error instanceof ApiError && error.status === 429) {
          return Math.max(1, error.retryAfterSeconds ?? 1) * 1_000
        }
        return Math.min(1_000 * 2 ** attempt, 5_000)
      },
      refetchOnWindowFocus: false,
    },
  },
})

